





















































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import QuestionType from './../../question/components/QuestionType.vue'
import QuestionBox from './../../question/components/QuestionBox.vue'
import { getPreviewInfo } from './../models/api'
import {
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from '../../question/model/api'
import { numToChinese } from '@/apps/question/model/numberToChinese'
import { getPaperListDetail } from './../models/api'
import { isObjectValueEqual } from '@/utils/urlUtils'

@Component({
  components: { QuestionType, QuestionBox }
})
export default class PaperPreview extends Vue {
  @Prop() id!: string | number
  @Prop() title!: string | number
  @Prop() subjectId!: string | number
  @Prop() data!: any
  @Prop() from!: string

  @Watch('data', { deep: true, immediate: true })
  onDataChange(val) {
    console.log(val)
    this.handleData(JSON.parse(JSON.stringify(val)))
  }

  public questions: any[] = []
  private get userInfo() {
    return this.$store.state.user_info
  }
  // mounted
  public mounted() {
    // this.handleData(JSON.parse(JSON.stringify(this.data)))
  }
  public handleCount(val) {
    return numToChinese(val)
  }
  public handleNumber(idx, questons, index, classification) {
    let count = 0
    if (index === 0) {
      return idx
    } else {
      for (let i = 0; i < index; i++) {
        count += classification[i].sequence.length
      }
      return count + idx
    }
  }
  public handleData(data) {
    data.forEach((element) => {
      element.sequence.forEach((n) => {
        n.showAnalysis = false
      })
    })
    console.log(this.cartInfo)
    this.onFlagChange(this.cartInfo, data)
  }
  public openAnalysis(itm) {
    console.log(itm)
    itm.showAnalysis = !itm.showAnalysis
    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.from,
      functionName: itm.showAnalysis ? '显示解析' : '收起解析'
    })
  }

  // 组卷相关
  private get subject() {
    return this.$store.state.subject
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get isCeping() {
    return this.$route.query.ceping === '1'
  }

  public addToCart(data) {
    if (data.val) {
      this.cartAdd(data.id)
    } else {
      this.cartDelete(data.id)
    }
  }

  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) {
      return
    }
    this.onFlagChange(this.cartInfo, this.questions)
  }

  public async cartAdd(id: number | string) {
    let params: any = {
      question_id: id,
      subject_id: this.subject.value
    }
    if (this.isCeping) {
      params.usage = 3
    }
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.from,
      buttonName: '加入组卷'
    })
    let data: any = await addQuestionToCart(params)
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public async cartDelete(id: number | string) {
    let params: any = {
      question_id: id,
      subject_id: this.subject.value
    }
    if (this.isCeping) {
      params.usage = 3
    }
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.from,
      buttonName: '移出组卷'
    })
    let data: any = await removeUestionFromCart(params)
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }

  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))
    if (!data) {
      return
    }
    for (let qs of dataCopy) {
      for (let n of qs.sequence) {
        if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
          n.inShoppingCart = true
        } else {
          n.inShoppingCart = false
        }
        if (n.showAnalysis) {
          n.showAnalysis = true
        } else {
          n.showAnalysis = false
        }
      }
    }
    this.questions = dataCopy
    console.log(this.questions)
  }

  public async chooseAll() {
    if (!this.userInfo || !this.userInfo.nickname) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    // 点击本页全选
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.from,
      buttonName: '本页全选'
    })
    //
    let arr = [...this.cartInfo.question_ids]
    let temp: any = []
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subject.value
    }
    if (this.isCeping) {
      params.usage = 3
    }
    console.log(params)
    for (let qs of this.questions) {
      for (let n of qs.sequence) {
        temp = [...temp, n.id]
      }
    }
    params.question_cart.question_ids = [...new Set([...arr, ...temp])]
    let data: any = await updateQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
    } else {
      this.$message.warning(data.error)
    }
  }
}
